<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- الترويسة والتحكم -->
    <div class="card shadow-sm border-top-danger mb-4 no-print">
      <div class="card-header bg-white py-3">
        <h5 class="mb-0 fw-bold text-danger">
          <i class="fas fa-balance-scale ms-2"></i> معالجة قواعد الرأفة (الراسبين بفارق بسيط)
        </h5>
      </div>
      <div class="card-body">
        <div class="row align-items-center">
          <div class="col-md-4">
            <label class="form-label fw-bold">حدود الرأفة (عدد الدرجات):</label>
            <select v-model="margin" class="form-select border-danger text-danger fw-bold">
           
              <option :value="1">درجة واحدة (1)</option>
              <option :value="2">درجتين (2)</option>
              <option :value="3">ثلاث درجات (3)</option>
              <option :value="4">اربع درجات (4)</option>
              <option :value="5">خمس درجات (5)</option>

            </select>
          </div>
          <div class="col-md-3 d-flex align-items-end">
            <button @click="fetchCandidates" class="btn btn-dark w-100" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm ms-2"></span>
              بحث عن الحالات
            </button>
          </div>
          <div class="col-md-5 text-end">
             <div v-if="candidates.length > 0" class="alert alert-warning py-2 mb-0 d-inline-block">
               تم العثور على <strong>{{ candidates.length }}</strong> حالة تستحق الرأفة
             </div>
          </div>
        </div>
      </div>
    </div>

    <!-- جدول النتائج -->
    <div v-if="candidates.length > 0" class="card shadow-sm">
      <div class="card-header bg-white d-flex justify-content-between align-items-center">
        <h6 class="fw-bold m-0">قائمة الطلاب المستحقين</h6>
        
        <button @click="applyAll" class="btn btn-danger fw-bold">
           <i class="fas fa-magic ms-2"></i> تطبيق الرأفة على الكل (جبر للنجاح)
        </button>
      </div>
      
      <div class="table-responsive">
        <table class="table table-hover align-middle text-center mb-0">
          <thead class="table-dark">
            <tr>
              <th><input type="checkbox" v-model="selectAll" @change="toggleSelectAll"></th>
              <th>جلوس</th>
              <th style="width: 25%">الطالب</th>
              <th>المدرسة</th>
              <th>المادة</th>
              <th>الدرجة الحالية</th>
              <th>النهاية الصغرى</th>
              <th>يحتاج</th>
              <th>الإجراء</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in candidates" :key="index" :class="{'table-active': selectedCases.includes(index)}">
              <td>
                <input type="checkbox" :value="index" v-model="selectedCases" class="form-check-input" style="transform: scale(1.2);">
              </td>
              <td class="fw-bold">{{ item.seat_no }}</td>
              <td class="text-start fw-bold text-primary">{{ item.name }}</td>
              <td class="small">{{ item.school }}</td>
              <td><span class="badge bg-secondary fs-6">{{ item.subject_name }}</span></td>
              
              <!-- الدرجة الحالية (حمراء) -->
              <td class="fw-bold text-danger fs-5">{{ item.current_score }}</td>
              
              <!-- النهاية الصغرى (خضراء) -->
              <td class="fw-bold text-success">{{ item.min_degree }}</td>
              
              <!-- الفارق -->
              <td>
                <span class="badge bg-warning text-dark border border-dark rounded-pill px-3">
                  {{ item.needed }} +
                </span>
              </td>

              <!-- زر التطبيق الفردي -->
              <td>
                <button @click="applyOne(item, index)" class="btn btn-outline-success btn-sm fw-bold">
                  جبر
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- رسالة فارغة -->
    <div v-else-if="searched && !loading" class="text-center py-5 text-muted">
      <i class="fas fa-check-circle fa-4x text-success mb-3 opacity-50"></i>
      <h4>لا توجد حالات راسبة في حدود {{ margin }} درجة/درجات.</h4>
    </div>

  </div>
</template>

<script>

import api from '@/api/axios';

export default {
  name: "MercyRulesManager",
  data() {
    return {
      loading: false,
      searched: false,
      margin: 1, // القيمة الافتراضية
      candidates: [],
      selectedCases: [], // يحمل الـ indexes المختارين
      selectAll: false
    };
  },
  methods: {
    async fetchCandidates() {
      this.loading = true;
      this.searched = true;
      this.candidates = [];
      this.selectedCases = [];
      this.selectAll = false;

      try {
        const res = await api.get('/admin/mercy-candidates', { params: { margin: this.margin } });
        this.candidates = res.data;
      } catch (error) {
        alert("حدث خطأ في جلب البيانات");
      } finally {
        this.loading = false;
      }
    },

    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedCases = this.candidates.map((_, index) => index);
      } else {
        this.selectedCases = [];
      }
    },

    // تطبيق على حالة واحدة
    async applyOne(item, index) {
      if(!confirm(`هل أنت متأكد من رفع درجة الطالب (${item.name}) في مادة (${item.subject_name}) لتصبح درجة النجاح؟`)) return;
      
      await this.sendApplyRequest([item]);
      // حذف الصف من الجدول محلياً
      this.candidates.splice(index, 1);
      // تحديث المصفوفة المختارة
      this.selectedCases = this.selectedCases.filter(i => i !== index).map(i => i > index ? i - 1 : i);
    },

    // تطبيق على الكل (أو المختارين)
    async applyAll() {
      let itemsToProcess = [];
      
      if (this.selectedCases.length > 0) {
        // إذا اختار المستخدم حالات محددة
        itemsToProcess = this.selectedCases.map(i => this.candidates[i]);
      } else {
        // إذا لم يختار، نطبق على الجميع
        if(!confirm(`تحذير: سيتم جبر وتنجيح جميع الطلاب الظاهرين في القائمة (${this.candidates.length} طالب). هل أنت متأكد؟`)) return;
        itemsToProcess = this.candidates;
      }

      if (itemsToProcess.length === 0) return;

      await this.sendApplyRequest(itemsToProcess);
      
      alert("تم تطبيق قواعد الرأفة بنجاح!");
      this.fetchCandidates(); // تحديث القائمة
    },

    // دالة الإرسال للباك إند
    async sendApplyRequest(items) {
      this.loading = true;
      try {
        await api.post('/admin/apply-mercy', { cases: items });
      } catch (error) {
        alert("حدث خطأ أثناء التنفيذ");
        console.error(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.border-top-danger { border-top: 4px solid #dc3545; }
.table-active { background-color: #e2e6ea; }
</style>